// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import BtnReplayEnd from "../core/prefabs/BtnReplayEnd";
import BtnNextLevel from "./BtnNextLevel";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { TransitionPoint } from '../app-routing';
import UIButton from '../core/components/UIButton';
import GameUI from '../scenes/GameUI';
import { GameDataHandler } from '../game/GameDataHandler';
import { Character, CharacterNameValues } from '../game/vehicle/Character';
import { RunSettingsHandler } from '../game/RunSettingsHandler';
import { LevelNameValues } from '../game/level/levels/level';
import { Sounds } from '../sounds';
import { LevelUtil } from './../game/level/levels/LevelUtil';
/* END-USER-IMPORTS */

export default class EndScreen extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.visible = false;
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // screen
    const screen = scene.add.container(0, -106);
    this.add(screen);

    // panel
    const panel = scene.add.image(0, 57, "endscreen", "screen.png");
    screen.add(panel);

    // bestScoreBox
    const bestScoreBox = scene.add.image(0, 170, "endscreen", "box-hiscore.png");
    screen.add(bestScoreBox);

    // iconBestScore
    const iconBestScore = scene.add.image(40, 170, "endscreen", "icon-hiscore.png");
    screen.add(iconBestScore);

    // bestScoreText
    const bestScoreText = scene.add.text(-26, 168, "", {});
    bestScoreText.setOrigin(0.5, 0.5);
    bestScoreText.text = "100";
    bestScoreText.setStyle({ "align": "center", "color": "#20e4e2", "fontFamily": "HouseMovements", "fontSize": "50px" });
    bestScoreText.setPadding({"top":2});
    screen.add(bestScoreText);

    // scoreBox
    const scoreBox = scene.add.image(0, 40, "endscreen", "box-score.png");
    screen.add(scoreBox);

    // iconScore
    const iconScore = scene.add.image(60, 40, "endscreen", "icon-score.png");
    screen.add(iconScore);

    // endScoreText
    const endScoreText = scene.add.text(-55, 34, "", {});
    endScoreText.setOrigin(0.5, 0.5);
    endScoreText.text = "0";
    endScoreText.setStyle({ "align": "center", "color": "#20e4e2", "fontFamily": "HouseMovements", "fontSize": "80px" });
    endScoreText.setPadding({"top":2});
    screen.add(endScoreText);

    // starBlue1
    const starBlue1 = scene.add.image(-87, -94, "endscreen", "star-blue-large.png");
    screen.add(starBlue1);

    // starBlue2
    const starBlue2 = scene.add.image(0, -94, "endscreen", "star-blue-large.png");
    screen.add(starBlue2);

    // starBlue3
    const starBlue3 = scene.add.image(87, -94, "endscreen", "star-blue-large.png");
    screen.add(starBlue3);

    // star1
    const star1 = scene.add.image(-87, -94, "endscreen", "star-gold-large.png");
    screen.add(star1);

    // star2
    const star2 = scene.add.image(0, -94, "endscreen", "star-gold-large.png");
    screen.add(star2);

    // star3
    const star3 = scene.add.image(87, -94, "endscreen", "star-gold-large.png");
    screen.add(star3);

    // characterBam
    const characterBam = scene.add.image(40, 255, "endscreen", "character-bam.png");
    this.add(characterBam);

    // characterBuff
    const characterBuff = scene.add.image(-409, 171, "endscreen", "character-buff.png");
    this.add(characterBuff);

    // characterRedbird
    const characterRedbird = scene.add.image(425, 180, "endscreen", "character-redbird.png");
    this.add(characterRedbird);

    // characterBatwing
    const characterBatwing = scene.add.image(-344, -217, "endscreen", "character-batwing.png");
    this.add(characterBatwing);

    // characterBibi
    const characterBibi = scene.add.image(345, -200, "endscreen", "character-bibi.png");
    this.add(characterBibi);

    // btnReplayEnd
    const btnReplayEnd = new BtnReplayEnd(scene, -170, 65);
    this.add(btnReplayEnd);

    // btnNextEnd
    const btnNextEnd = new BtnNextLevel(scene, 170, 65);
    this.add(btnNextEnd);

    // lists
    const stars = [star1, star2, star3];
    const starBacks = [starBlue1, starBlue2, starBlue3];

    this.cover = cover;
    this.screen = screen;
    this.panel = panel;
    this.bestScoreBox = bestScoreBox;
    this.iconBestScore = iconBestScore;
    this.bestScoreText = bestScoreText;
    this.scoreBox = scoreBox;
    this.iconScore = iconScore;
    this.endScoreText = endScoreText;
    this.star1 = star1;
    this.star2 = star2;
    this.star3 = star3;
    this.characterBam = characterBam;
    this.characterBuff = characterBuff;
    this.characterRedbird = characterRedbird;
    this.characterBatwing = characterBatwing;
    this.characterBibi = characterBibi;
    this.btnReplayEnd = btnReplayEnd;
    this.btnNextEnd = btnNextEnd;
    this.stars = stars;
    this.starBacks = starBacks;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.newHighScore = false;
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private screen: Phaser.GameObjects.Container;
  private panel: Phaser.GameObjects.Image;
  private bestScoreBox: Phaser.GameObjects.Image;
  private iconBestScore: Phaser.GameObjects.Image;
  private bestScoreText: Phaser.GameObjects.Text;
  private scoreBox: Phaser.GameObjects.Image;
  private iconScore: Phaser.GameObjects.Image;
  private endScoreText: Phaser.GameObjects.Text;
  private star1: Phaser.GameObjects.Image;
  private star2: Phaser.GameObjects.Image;
  private star3: Phaser.GameObjects.Image;
  private characterBam: Phaser.GameObjects.Image;
  private characterBuff: Phaser.GameObjects.Image;
  private characterRedbird: Phaser.GameObjects.Image;
  private characterBatwing: Phaser.GameObjects.Image;
  private characterBibi: Phaser.GameObjects.Image;
  private btnReplayEnd: BtnReplayEnd;
  private btnNextEnd: BtnNextLevel;
  private stars: Phaser.GameObjects.Image[];
  private starBacks: Phaser.GameObjects.Image[];
  public screenStartY: number = 700;
  public characterStartY: number = 1300;

  /* START-USER-CODE */
  private particles!: Phaser.GameObjects.Particles.ParticleEmitterManager;
  private endScore!: number;
  private highScore!: number;
  private earnedPoints!: number;
  private earnedStars: number = 2;
  private newHighScore: boolean;

  protected bamX: number = 0;
  protected bamY: number = 0;
  protected bibiX: number = 0;
  protected bibiY: number = 0;
  protected buffX: number = 0;
  protected buffY: number = 0;
  protected redbirdX: number = 0;
  protected redbirdY: number = 0;
  protected batwingX: number = 0;
  protected batwingY: number = 0;

  public awake() {
    this.cover.setInteractive();

    this.btnReplayEnd.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.Replay);
    });

    this.btnNextEnd.once(UIButton.events.clicked, () => {
      let currentLevel: LevelNameValues = RunSettingsHandler.getSelectedLevel(this.scene);
      let nextLevel: LevelNameValues | undefined = LevelUtil.getNextLevel(currentLevel);

      if (nextLevel) this.scene.events.emit(GameUI.events.NextLevel, nextLevel);
      else this.scene.events.emit(GameUI.events.LevelSelect);
    });

    this.particles = this.scene.make.particles(
      {
        key: 'endscreen',
        emitters: [
          {
            name: 'explode',
            on: false,
            frame: ['money1.png', 'money2.png'],
            angle: { min: -200, max: 0 },
            rotate: { min: 0, max: 360 },
            scale: { start: 0.8, end: 1.5, ease: Phaser.Math.Easing.Cubic.Out },
            alpha: { start: 1, end: 0, ease: Phaser.Math.Easing.Cubic.In },
            speed: { min: 400, max: 900 },
            gravityY: 600,
            lifespan: 2000,
            quantity: 1
          }
        ]
      },
      false
    );
    this.add(this.particles);
  }

  public activate(endScore: number, highScore: number, earnedPoints: number, earnedStars: number, char: CharacterNameValues) {
    this.bamX = this.characterBam.x;
    this.bamY = this.characterBam.y;
    this.buffX = this.characterBuff.x;
    this.buffY = this.characterBuff.y;
    this.batwingX = this.characterBatwing.x;
    this.batwingY = this.characterBatwing.y;
    this.bibiX = this.characterBibi.x;
    this.bibiY = this.characterBibi.y;
    this.redbirdX = this.characterRedbird.x;
    this.redbirdY = this.characterRedbird.y;

    this.characterBam.x -= 2;
    this.characterBam.y += 10;
    this.characterBam.scale = 0;

    this.characterBibi.x -= 250;
    this.characterBibi.y -= 10;
    this.characterBibi.scale = 0;

    this.characterBuff.x += 250;
    this.characterBuff.y += 10;
    this.characterBuff.scale = 0;

    this.characterBatwing.x -= 250;
    this.characterBatwing.y += 140;
    this.characterBatwing.scale = 0;

    this.characterRedbird.x -= 250;
    this.characterRedbird.y += 10;
    this.characterRedbird.scale = 0;

    this.endScore = Math.trunc(endScore);
    this.highScore = Math.trunc(highScore);
    this.earnedPoints = earnedPoints;
    this.earnedStars = earnedStars;

    this.newHighScore = false;
    if (this.endScore > this.highScore || this.highScore == 0) this.newHighScore = true;

    this.bestScoreText.setText(this.highScore.toString());

    this.transitionIn();
  }

  protected transitionIn() {
    let startDelay = 400;

    this.cover.alpha = 0;
    this.scene.add.tween({
      targets: this.cover,
      alpha: { from: 0, to: 1 },
      duration: 300,
      delay: startDelay,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    let screenFinishY = this.screen.y;
    this.screen.y = this.screenStartY;
    this.scene.add.tween({
      targets: this.screen,
      y: { from: this.screenStartY, to: screenFinishY },
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      delay: startDelay + 300,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.ChargeComplete1, Sounds.Channel.SFX, { volume: 1.0 });
      },
      onStartScope: this
    });

    this.scene.time.delayedCall(startDelay + 800, () => {
      app.audioHandler.playSound(this.scene, Sounds.Track.Pickup2, Sounds.Channel.SFX);
      let emitter = this.particles.emitters.getByName('explode');
      emitter?.explode(40, 0, -120);
      this.scene.children.bringToTop(this.particles);
    });

    let characterDelay = startDelay + 1000;

    this.scene.add.tween({
      targets: this.characterBam,
      x: this.bamX,
      y: this.bamY,
      scale: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: characterDelay,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.BamCheer1, Sounds.Channel.SFX, { volume: 0.8 });
      },
      onStartScope: this
    });

    this.scene.add.tween({
      targets: this.characterBibi,
      x: this.bibiX,
      y: this.bibiY,
      scale: 1,
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: characterDelay + 50,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.BibiCheer1, Sounds.Channel.SFX, { volume: 0.8 });
      },
      onStartScope: this
    });

    this.scene.add.tween({
      targets: this.characterBuff,
      x: this.buffX,
      y: this.buffY,
      scale: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: characterDelay + 100,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.BuffCheer1, Sounds.Channel.SFX, { volume: 0.8 });
      },
      onStartScope: this
    });

    this.scene.add.tween({
      targets: this.characterBatwing,
      x: this.batwingX,
      y: this.batwingY,
      scale: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: characterDelay + 500,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.BatwingCheer1, Sounds.Channel.SFX, { volume: 0.8 });
      },
      onStartScope: this
    });

    this.scene.add.tween({
      targets: this.characterRedbird,
      x: this.redbirdX,
      y: this.redbirdY,
      scale: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: characterDelay + 200,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.RedbirdCheer1, Sounds.Channel.SFX, { volume: 0.8 });
      },
      onStartScope: this
    });

    this.iconScore.alpha = 0;
    this.endScoreText.alpha = 0;
    this.scoreBox.alpha = 0;
    this.scene.add.tween({
      targets: [this.iconScore, this.endScoreText, this.scoreBox],
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: startDelay + 2000,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.CompOn1, Sounds.Channel.SFX, { volume: 1.0 });
      },
      onStartScope: this
    });

    this.iconBestScore.alpha = 0;
    this.bestScoreText.alpha = 0;
    this.bestScoreBox.alpha = 0;
    this.scene.add.tween({
      targets: [this.iconBestScore, this.bestScoreText, this.bestScoreBox],
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: startDelay + 2500,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.CompOn2, Sounds.Channel.SFX, { volume: 1.0 });
      },
      onStartScope: this
    });

    let endTimeCounterTween = this.scene.tweens.addCounter({
      from: 0,
      to: this.endScore,
      duration: 2000,
      delay: startDelay + 2750,
      ease: Phaser.Math.Easing.Linear,
      onUpdate: (tween, target, param) => {
        this.endScoreText.text = Math.floor(endTimeCounterTween.getValue()).toString();
      }
    });

    if (this.newHighScore) {
      let bestTimeCounterTween = this.scene.tweens.addCounter({
        from: this.highScore,
        to: this.endScore,
        duration: 2000,
        delay: startDelay + 5000,
        ease: Phaser.Math.Easing.Linear,
        onStart: () => {},
        onUpdate: (tween, target, param) => {
          this.bestScoreText.text = Math.floor(bestTimeCounterTween.getValue()).toString();
        },
        onComplete: () => {
          this.bestScoreText.setColor('#ffef00');

          this.scene.add.tween({
            targets: this.bestScoreText,
            alpha: { from: 1, to: 0 },
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.InOut,
            repeat: 2,
            yoyo: true,
            delay: 250
          });
        }
      });
    }

    for (const starBack of this.starBacks) {
      starBack.alpha = 0;
      this.scene.add.tween({
        targets: starBack,
        alpha: 1,
        duration: 500,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: startDelay + 2500
      });
    }

    var starnum: number = 0;
    for (const star of this.stars) {
      star.alpha = 0;
      star.scale = 0;
      if (starnum < this.earnedStars) {
        this.scene.add.tween({
          targets: star,
          alpha: 1,
          scale: 1,
          duration: 500,
          ease: Phaser.Math.Easing.Cubic.Out,
          delay: startDelay + 2800 + starnum * 400,
          onStart: () => {
            app.audioHandler.playSound(this.scene, Sounds.Track.Pickup2, Sounds.Channel.SFX, { volume: 1.0 });
          },
          onStartScope: this
        });
      }
      starnum++;
    }

    this.btnNextEnd.alpha = 0;
    this.btnReplayEnd.alpha = 0;
    this.scene.add.tween({
      targets: [this.btnNextEnd, this.btnReplayEnd],
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      delay: startDelay + 3000,
      onStart: () => {
        app.audioHandler.playSound(this.scene, Sounds.Track.CompSwitch1, Sounds.Channel.SFX, { volume: 1.0 });
      },
      onStartScope: this
    });

    this.btnNextEnd.UIButton.pulseDelay = startDelay + 3500;
    // this.scene.time.delayedCall(startDelay + 3500, this.startIdles, [], this);
  }

  protected startIdles() {
    this.scene.add.tween({
      targets: [this.btnNextEnd],
      scaleX: 1.1,
      scaleY: 1.1,
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      yoyo: true,
      repeat: -1
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
